interface ReviewCardProps {
  name: string;
  rating: number;
  content: string;
  date: string;
  product: string;
}

export default function ReviewCard({ name, rating, content, date, product }: ReviewCardProps) {
  const initials = name.charAt(0);

  return (
    <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 font-semibold text-sm">
          {initials}
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground-800">{name}</p>
          <p className="text-xs text-foreground-400">{date} · {product}</p>
        </div>
      </div>
      <div className="flex items-center text-accent-500 mb-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <i key={i} className={`text-xs ${i < rating ? 'ri-star-fill' : 'ri-star-line text-foreground-300'}`}></i>
        ))}
      </div>
      <p className="text-sm text-foreground-600 leading-relaxed">{content}</p>
    </div>
  );
}